query Avatar($id: ID!) {
  file: avatar(id: $id) {
    id
    url
  }
}
